module.exports = __webpack_public_path__ + "static/media/logo_parque_animado.b32b623d.gif";